import React from 'react'
import { Row, Col, ControlLabel, Alert } from 'react-bootstrap'

import { Button } from 'syft-acp-atoms/Button'

import { SpotOptions } from './SpotOptions'
import { isOtherReason } from './helpers'
import { CancelReason, ShiftOverbookCover, SpotDecision, WorkerJobBooking } from './types'

// Step 2's body: what happens to the vacated spot — keep it or remove it.
// `hasOverbookCover` only picks which wording keeping it gets.
export const SpotDecisionStep = ({
  count,
  worker,
  reason,
  reasonLabel,
  otherReason,
  spotDecision,
  setSpotDecision,
  hasOverbookCover,
  coverPreview,
  onBack,
}: {
  count: number
  worker: { first_name?: string; last_name?: string }
  reason: CancelReason
  reasonLabel: string | null | undefined
  otherReason: string | undefined
  spotDecision: SpotDecision
  setSpotDecision: (decision: SpotDecision) => void
  hasOverbookCover: boolean
  coverPreview: { booking: WorkerJobBooking; cover: ShiftOverbookCover }[]
  onBack: () => void
}) => (
  <>
    <Row>
      <Col md={12}>
        <Button kind="regular" onClick={onBack} className="back-link">
          ‹ Back to shift selection
        </Button>
        <ControlLabel>
          Cancelling {count} {count === 1 ? 'shift' : 'shifts'} for {worker.first_name} {worker.last_name} ·
          reason: {reasonLabel ?? reason}
          {isOtherReason(reasonLabel ?? reason) && otherReason ? ` (${otherReason})` : ''}
        </ControlLabel>
      </Col>
    </Row>

    <Row style={{ marginBlockStart: 12 }}>
      <Col md={12}>
        <ControlLabel>What should happen to the {count === 1 ? 'spot' : 'spots'}?</ControlLabel>

        <SpotOptions
          count={count}
          coverPreview={coverPreview}
          hasOverbookCover={hasOverbookCover}
          spotDecision={spotDecision}
          setSpotDecision={setSpotDecision}
        />

        <Alert bsStyle="danger" style={{ marginBlockStart: 12 }}>
          Cancelling happens <strong>immediately</strong> when you click, and{' '}
          <strong>cannot be undone</strong>.
        </Alert>
      </Col>
    </Row>
  </>
)
